import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { usePlaidLink } from "react-plaid-link";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";
import api from "@/lib/api";

function readStoredToken() {
  try { return localStorage.getItem("mmh_plaid_link_token"); } catch { return null; }
}

function clearStoredToken() {
  try { localStorage.removeItem("mmh_plaid_link_token"); } catch { /* ignore */ }
}

export default function PlaidOAuthReturn() {
  const navigate = useNavigate();
  const linkToken = useRef(readStoredToken()).current;
  const opened = useRef(false);

  const { open, ready } = usePlaidLink({
    token: linkToken,
    receivedRedirectUri: window.location.href,
    onSuccess: async (public_token) => {
      clearStoredToken();
      try {
        await api.post("/plaid/exchange-public-token", { public_token });
        toast.success("Bank linked!", { description: "Scanning for recurring charges…" });
        try { await api.post("/plaid/sync"); } catch { /* PRODUCT_NOT_READY is fine */ }
      } catch (e) {
        console.error(e);
        toast.error("Could not finish linking your bank. Please try again.");
      }
      navigate("/", { replace: true });
    },
    onExit: (err) => {
      clearStoredToken();
      if (err) {
        console.warn("Plaid OAuth exit with error", err);
        toast.error("Bank linking didn't complete.", {
          description: "You can try connecting again from the dashboard.",
        });
      }
      navigate("/", { replace: true });
    },
  });

  useEffect(() => {
    if (!linkToken) {
      navigate("/", { replace: true });
      return;
    }
    if (ready && !opened.current) {
      opened.current = true;
      open();
    }
  }, [ready, open, linkToken, navigate]);

  return (
    <div
      className="min-h-screen flex flex-col items-center justify-center gap-4 bg-[#07211C] text-[#CDE0D9]"
      data-testid="plaid-oauth-return"
    >
      <Loader2 className="w-8 h-8 animate-spin text-[#22E07A]" />
      <p className="font-extrabold text-lg" style={{ fontFamily: "Outfit, sans-serif" }}>
        Finishing your bank connection…
      </p>
      <p className="text-sm font-medium text-[#93B1A8]">Hang tight, hero. Almost there.</p>
    </div>
  );
}
